import styled from 'styled-components'

export const PageInner = styled.div`
    padding: 15px 0;

`

